module.exports = __webpack_public_path__ + "static/media/Ho-Oh_gaussian2.dca85560.png";